
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-hub/article",
      function () {
        return require("private-next-pages/content-hub/article.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-hub/article"])
      });
    }
  